module.exports = __webpack_public_path__ + "static/card2-8e096ed7eac84a4c986c21e759de4fce.png";